import {
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator,
} from "@/components/ui";
import { Fragment } from "react";

type MatterStatusSelectItem = {
  group?: string;
  label: string;
  value: string;
};

export function MatterStatusSelectItems({
  items,
}: {
  items: MatterStatusSelectItem[];
}) {
  const groupedItems = Array.from(
    items.reduce((groups, item) => {
      const groupItems = groups.get(item.group) ?? [];
      groupItems.push(item);
      groups.set(item.group, groupItems);
      return groups;
    }, new Map<string | undefined, MatterStatusSelectItem[]>()),
  );

  return groupedItems.map(([group, options], index) =>
    group ? (
      <Fragment key={group}>
        {index > 0 && <SelectSeparator />}
        <SelectGroup>
          <SelectLabel>{group}</SelectLabel>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </Fragment>
    ) : (
      <Fragment key="ungrouped-statuses">
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </Fragment>
    ),
  );
}
